import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import {login} from '../auth/identityAuth';
import Button from '@material-ui/core/Button';

const Expired = (props: any) => {
  return (
    <div>
      <Typography gutterBottom={true}>
        It has been a while since you last logged in. For your own safety, you have been logged out.
      </Typography>
      <Typography>
        <Button onClick={login}>Log in</Button>
      </Typography>
    </div>
  )
}

export default Expired


// WEBPACK FOOTER //
// ./src/modules/core/pages/Expired.tsx